/**
 * This module abstracts the specific auth service to present a generic interface. Callable members of
 * the interface are:
 *  - authenticate()
 *  - start()
 *  - completeAuthentication()
 *  - logout()
 *  - isAuthenticated()
 *  - getIdToken()
 *  - setSession()
 *  - getSession()
 */
import CognitoService from './cognito.js'
const AuthService = CognitoService
export default AuthService



// WEBPACK FOOTER //
// src/services/auth/index.js